import { storeURL } from "../Config/Url";
import axios from "axios";

export const storeService = {
  get,
  getById,
  create,
  update,
  deleteStore,
  getPosByStoreId,
};

async function get({
  tenantId,
  searchText,
  isDeactivated,
  sortName,
  isAsc,
  pageIndex,
  pageSize,
}) {
  return axios
    .put(`${storeURL}/search`, {
      tenantId,
      searchText,
      isDeleted: isDeactivated,
      sortName,
      isAsc,
      pageIndex,
      pageSize,
    })
    .then((res) => res)
    .catch((err) => {
      console.log("err", err.response);
    });
}

async function getById(storeId) {
  return axios
    .get(`${storeURL}/${storeId}`)
    .then((res) => res)
    .catch((err) => {
      console.log("err", err.response);
    });
}

async function create({
  tenantId,
  description,
  tag,
  type,
  footerNote,
  street,
  streetNumber,
  streetNumberExtension,
  city,
  postalNumber,
  countryId,
}) {
  return axios
    .post(storeURL, {
      tenantId,
      description,
      tag,
      type,
      footerNote,
      street,
      streetNumber,
      streetNumberExtension,
      city,
      postalNumber,
      countryId,
    })
    .then((res) => res)
    .catch((err) => {
      console.log("err", err.response);
    });
}

async function update({
  storeId,
  tenantId,
  description,
  tag,
  type,
  footerNote,
  priceListId,
  street,
  streetNumber,
  streetNumberExtension,
  city,
  postalNumber,
  countryId,
  useAccounting,
  useFinancial,
}) {
  return axios
    .put(`${storeURL}/${storeId}`, {
      storeId,
      tenantId,
      description,
      tag,
      type,
      footerNote,
      priceListId,
      street,
      streetNumber,
      streetNumberExtension,
      city,
      postalNumber,
      countryId,
      useAccounting,
      useFinancial,
    })
    .then((res) => res)
    .catch((err) => {
      console.log("err", err.response);
    });
}

async function deleteStore(storeId) {
  return axios
    .delete(`${storeURL}/${storeId}`)
    .then((res) => res)
    .catch((err) => err.response);
}

async function getPosByStoreId(storeId) {
  return axios
    .get(`${storeURL}/${storeId}/pos`)
    .then((res) => res)
    .catch((err) => console.log(err.response));
}
